import { AlumnoFields } from "./AlumnoForm";
import { ClientSectionSlot as BaseClientSectionSlot } from "../../common/components";
import SalesPersonSelect from "../../common/components/SalesPersonSelect";

export const ClientSectionSlot = ({ invoiceData, active, ...baseProps }) => {
    return (
        <>
            <BaseClientSectionSlot {...baseProps} />
            <AlumnoFields isRequired={false} />
            <SalesPersonSelect />
        </>
    );
};
